(ns ^:dev/always bp-clients.tv-app.api.graphql.player
  (:require
   [bp-clients.tv-app.api.graphql.utils :refer [query-builder]]
   [graphql-builder.core :as graphql-builder])
  (:require-macros [graphql-builder.parser :refer [defgraphql]]))

(defgraphql graphql-raw-queries
  "graphql/media/update-checkpoint.graphql"
  "graphql/player/update-user-settings.graphql")

(def ^:private query-map (graphql-builder/query-map graphql-raw-queries))
(def ^:private update-checkpoint-raw (get-in query-map [:mutation :update-checkpoint]))
(def ^:private update-user-settings-raw (get-in query-map [:mutation :update-user-settings]))

(defn update-checkpoint-mutation
  "Sends a update-checkpoint mutation"
  [{:keys [media-id playlist-id checkpoint]}]
  (query-builder update-checkpoint-raw {:input {:media      media-id
                                                :playlist   playlist-id
                                                :checkpoint checkpoint}}))

(defn update-user-settings-mutation
  "Sends a update-user-settings mutation"
  [{:keys [audio subtitles]}]
  (query-builder update-user-settings-raw
                 {:input {:player
                          {:language {:audio     (or audio "")
                                      :subtitles (or subtitles "")}}}}))

(comment
  ;; see the corresponding .graphql files for more impormation
  (update-checkpoint-mutation {:media-id "123" :playlist-id "321" :checkpoint 100.1})

  nil)
